import { faEdit, faLock, faLockOpen, faSave, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { memo, useContext, useEffect, useState } from 'react';
import { Tooltip } from 'react-tooltip';
import { Handle, useReactFlow, useStoreApi, Position } from 'reactflow';
import AppContext from '../../../contexts/AppContext';

function PBarrier({ id, data }) {
  const [lockedByUsername, setLockedByUsername] = useState(data.lockedByUsername)
  const [text, setText] = useState(data.text)
  const { user, openModal } = useContext(AppContext);
  const keys = Object.keys(data.handles);

  useEffect(() => {
    setLockedByUsername(data.lockedByUsername)
  }, [data.lockedByUsername])

  useEffect(() => {
    setText(data.text)
  }, [data.text])

  return (
    <>
      <div className="custom-node__header-barrier rounded-[6px] bg-zinc-200 flex justify-between">
        <strong>Prevention</strong>
        {/* <div className='text-[8px] font-semibold lowercase ml-auto'>Node-{id}</div> */}
        <div className="custom-node__header-barrier bg-zinc-200 flex justify-between">
          {lockedByUsername ?
            <div><span className='text-[8px] bg-gray-100 px-1 rounded lowercase'><FontAwesomeIcon icon={faLock} /> <span className='ml-1'>{lockedByUsername == user?.sub ? 'you' : data.lockedByUsername}</span></span> </div>
            : <><div data-tooltip-content={'Edit/Lock'} data-tooltip-id='edit' onClick={async () => {
              const status = await data.acquireLock();
              if (status == 200) {
                setLockedByUsername(user.sub)
              }
            }} className='text-slate-600 bg-white ml-2 px-[4px] rounded cursor-pointer'>
              <FontAwesomeIcon icon={faEdit} size='sm' />
            </div>
              <Tooltip place='top' id='edit' /></>}

          {(lockedByUsername === user?.sub) &&
            <>
              <div data-tooltip-content={'Save'} data-tooltip-id='save' onClick={() => data.update(text)} className='text-teal-600 bg-white ml-2 px-[4px] rounded cursor-pointer'>
                <FontAwesomeIcon icon={faSave} size='sm' />
              </div>
              <Tooltip place='top' id='save' />
            </>
          }
        </div>

        <div onClick={() => {
          openModal("Delete Strategy?",
            `Are you sure you want to delete strategy "${id}"`,
            () => { data.delete(id, data.nfor) }
          )
        }} className='text-red-600 bg-white ml-2 px-[4px] rounded cursor-pointer'>
          <FontAwesomeIcon icon={faTrash} size='sm' />
        </div>
      </div>
      
      {/* <div className="custom-node__body-barrier"> */}
      <div className=''>
        <textarea
          value={text}
          disabled={(lockedByUsername !== user?.sub)}
          onChange={(e) => { data.text = e.currentTarget.value; setText(data.text); }}
          placeholder={'Prevention description'}
          rows={"4"} className="shadow bg-white appearance-none border rounded-b-md w-full py-2 px-3 text-gray-700 
            leading-tight focus:outline-none focus:shadow-outline"
        />
      </div>
      <Handle type="target" position={Position.Left} id="handle-left" />
      <Handle type="source" position={Position.Right} id="handle-right" />

      {/* <Handle type="target" position={Position.Left} id={keys[0]} />
      <Handle type="source" position={Position.Right} id={keys[1]} /> */}
    </>
  );
}

export default memo(PBarrier);
